// slider home page
document.addEventListener('DOMContentLoaded', function() {
    
    const slides = document.getElementById('home-slider').querySelectorAll('.project-item');
    let currentIndex = 0;
    // console.log(slides)
    // console.log(currentIndex)

    function showSlide(index) {
        slides.forEach((slide, i) => {
            slide.classList.remove('active');
            if (i === index) {
                slide.classList.add('active');
            }
        });
    }

    function nextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        showSlide(currentIndex);
    }

    // Initialize the slider
    showSlide(currentIndex);
    setInterval(nextSlide, 2000); 
});